var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAu = function SvgIconAu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.968 12H12v-.032z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.262V0h-.002C5.372.002 0 5.374 0 12.001h6.26V8.475l3.526 3.526h2.182l.032-.032V9.787L8.474 6.262z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.071 1.566A12.06 12.06 0 0 0 1.565 6.07v5.93h3.13V4.696H12v-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.525 7.738 6.26H6.262L12 12.002z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.237 14.086.659 1.377 1.487-.343-.666 1.373 1.196.949-1.489.335.004 1.527-1.19-.955-1.192.955.005-1.527-1.49-.335 1.197-.949-.667-1.373 1.488.344zM17.967 16.695l.33.689.743-.172-.333.687.598.474-.745.168.002.763-.595-.477-.596.477.002-.763-.744-.168.598-.474-.333-.687.744.172zM14.903 9.391l.33.689.743-.172-.333.687.598.474-.744.168.002.763-.596-.477-.595.477.002-.763-.745-.168.598-.474-.333-.687.744.172zM17.967 5.218l.33.688.743-.172-.333.687.598.474-.745.168.002.763-.595-.477-.596.477.002-.763-.744-.168.598-.474-.333-.687.744.172zM20.642 8.348l.329.688.744-.172-.334.687.599.474-.745.168.002.763-.595-.477-.596.477.002-.763-.744-.168.598-.474-.333-.687.743.172zM18.729 12l.259.797h.838l-.678.493.26.797-.679-.492-.678.492.259-.797-.678-.493h.838z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconAu;